import React from 'react';
import { Link } from 'react-router-dom';

function Footer({ data }) {
  return (
    <footer className="footer" id="contact">
      <div>
        <p className="brand-name">{data.brand}</p>
        <p>{data.tagline}</p>
      </div>
      <div>
        <p className="footer-title">{data.visitTitle}</p>
        <p>{data.visit}</p>
      </div>
      <div>
        <p className="footer-title">{data.contactTitle}</p>
        <p>
          <a href={`tel:${data.phone.replace(/[^+\d]/g, '')}`}>{data.phone}</a>
        </p>
        <p>
          <a href={`mailto:${data.email}`}>{data.email}</a>
        </p>
      </div>
      <div>
        <p className="footer-title">Quick Links</p>
        <p>
          <Link to="/">Home</Link>
        </p>
        <p>
          <Link to="/gallery">Gallery</Link>
        </p>
        <p>
          <Link to="/products">Products</Link>
        </p>
        <p>
          <Link to="/contact">Contact</Link>
        </p>
        <p>
          <Link to="/demo">Book a Demo</Link>
        </p>
        <p>
          <a href="/invoice">Invoice builder</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
